export var ERports;
(function (ERports) {
    ERports["HOLDINGS"] = "holdings";
    ERports["PNL"] = "pnlReport";
})(ERports || (ERports = {}));
export var ERevampReportReducers;
(function (ERevampReportReducers) {
    ERevampReportReducers["HOLDING"] = "holding";
    ERevampReportReducers["PNL"] = "pnlReport";
    ERevampReportReducers["FamilyTagging"] = "familyDetails";
    ERevampReportReducers["DownloadNSendEmailReport"] = "downloadNSendEmailReport";
})(ERevampReportReducers || (ERevampReportReducers = {}));
